// This file now re-exports analytics data from the API via a React Query hook.
// The dummy arrays below are used as fallback defaults while the API loads.

import { useQuery } from '@tanstack/react-query'
import type { DashboardData } from '@cmms/api-client'
import { api } from '../../lib/api'

export function useDashboard(days = 30) {
  return useQuery<DashboardData>({
    queryKey: ['analytics-dashboard', days],
    queryFn: () => api.analytics.dashboard(days),
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
    retry: 1,
  })
}

// ─── Fallback defaults (shown while loading) ─────────────────────────────────

const EMPTY_WORK_BUCKET = { total: 0, open: 0, overdue: 0, inProgress: 0, resolved: 0, closed: 0, scheduled: 0 }

export const EMPTY_KPIS: DashboardData['kpis'] = {
  openWorkOrders: 0,
  overdueWorkOrders: 0,
  criticalAssets: 0,
  complianceRate: 0,
  highPriorityCount: 0,
  avgDelayDays: 0,
  trends: { openWos: 0, overdue: 0, critical: 0 },
  sparklines: { openWorkOrders: [0], overdue: [0], criticalAssets: [0] },
  workOrders: EMPTY_WORK_BUCKET,
  tasks: EMPTY_WORK_BUCKET,
}
